import React from 'react';
import SimplePageHeader from '@/header/SimplePageHeader';
import BonusDashboardTabs from '@/header/BonusDashboardTabs';

function BonusDashboardHeader({ active }) {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <BonusDashboardTabs active={active} />
        </SimplePageHeader>
    );
}

export default BonusDashboardHeader;
